module.exports = __webpack_public_path__ + "close.440423edd047752efe7fb17a17cc3d6a.svg";